import { useEvents } from "../../../../hooks";
import { useMarketStorefrontSessionId } from "../../../../hooks/useMarketStorefrontSessionTracking";
import { getSellarWebsiteUtms } from "../../../../utils/utmHelper";

type Source =
  | "suppliers-list"
  | "market"
  | "delivered-by-sellar-page"
  | "end-of-checkout";

type AddMoreTitle =
  | "Add more from different makers clicked"
  | "Add more to your delivery clicked";

export const useDiscoveryV2DistributionTracking = () => {
  const { track } = useEvents();

  const { sessionId, journeySource, updateJourneySource } =
    useMarketStorefrontSessionId();

  const onTrackSupplierClick = ({
    supplierName,
    source,
  }: {
    supplierName: string;
    source: Source;
  }) => {
    const currentSession =
      source === "suppliers-list"
        ? updateJourneySource("suppliers-list")
        : { sessionId };
    track("Delivered By Sellar - Supplier Clicked", {
      supplier: supplierName,
      source,
      sessionId: currentSession.sessionId,
      ...getSellarWebsiteUtms(),
    });
  };

  const onTrackBannerClick = ({ source }: { source: Source }) => {
    const currentSession =
      source === "suppliers-list"
        ? updateJourneySource("suppliers-list")
        : { sessionId };
    track("Delivered By Sellar - Banner Clicked", {
      source,
      sessionId: currentSession.sessionId,
      ...getSellarWebsiteUtms(),
    });
  };

  const onTrackProductClick = ({
    source,
    supplierName,
    productName,
  }: {
    source: Source;
    supplierName: string;
    productName: string;
  }) => {
    track("Delivered By Sellar - Product Clicked", {
      source,
      sessionId,
      supplier: supplierName,
      product: productName,
      ...getSellarWebsiteUtms(),
    });
  };

  const onTrackLandingPageViewed = () => {
    const currentSession = sessionId
      ? { sessionId, journeySource }
      : updateJourneySource("direct");
    track("Delivered By Sellar - Page Viewed", {
      ...(currentSession.sessionId
        ? { sessionId: currentSession.sessionId }
        : {}),
      journeySource: currentSession.journeySource,
      ...getSellarWebsiteUtms(),
    });
  };

  const onTrackAddMoreClick = ({
    title,
    source,
  }: {
    title: AddMoreTitle;
    source: Source;
  }) => {
    track(title, {
      source,
      sessionId,
      ...getSellarWebsiteUtms(),
    });
  };

  return {
    onTrackSupplierClick,
    onTrackBannerClick,
    onTrackProductClick,
    onTrackLandingPageViewed,
    onTrackAddMoreClick,
  };
};
